import { render, staticRenderFns } from "./addapp-list.vue?vue&type=template&id=68105662&scoped=true"
import script from "./addapp-list.vue?vue&type=script&lang=js"
export * from "./addapp-list.vue?vue&type=script&lang=js"
import style0 from "./addapp-list.vue?vue&type=style&index=0&id=68105662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68105662",
  null
  
)

export default component.exports